import { TrustpilotReview, SubjectType, trustpilotReviews } from './data';

/**
 * 根据科目筛选评论
 * - subjects === 'all' 的评论适用于所有科目
 * - subjects 数组包含当前科目的评论也适用
 */
export function filterReviewsBySubject(
  subject: SubjectType,
): TrustpilotReview[] {
  return trustpilotReviews.filter(review => {
    if (review.subjects === 'all') {
      return true;
    }
    return review.subjects.includes(subject);
  });
}

/**
 * Fisher-Yates 洗牌算法，随机打乱数组
 */
function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/**
 * 随机选择 n 条评论
 */
export function getRandomReviews(
  reviews: TrustpilotReview[],
  count: number,
): TrustpilotReview[] {
  const shuffled = shuffleArray(reviews);
  return shuffled.slice(0, count);
}

/**
 * 根据科目筛选后随机选择指定数量的评论
 * 用于科目页面展示
 * @param subject 科目类型
 * @param count 需要的评论数量，默认 3
 */
export function getReviewsForSubject(
  subject: SubjectType,
  count: number = 3,
): TrustpilotReview[] {
  const filtered = filterReviewsBySubject(subject);
  return getRandomReviews(filtered, count);
}

/**
 * 获取全部评论，按评价日期倒序排列（最新在前）
 * 用于好评页 (Wall of Love) 展示，3 列布局从左到右、从上到下依次为最新到最旧
 */
export function getAllReviews(): TrustpilotReview[] {
  return [...trustpilotReviews].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
}

/**
 * 根据科目获取评论数量统计
 */
export function getReviewCountBySubject(): Record<SubjectType | 'all', number> {
  const counts: Record<SubjectType | 'all', number> = {
    chinese: 0,
    math: 0,
    english: 0,
    all: 0,
  };

  trustpilotReviews.forEach(review => {
    if (review.subjects === 'all') {
      counts.all++;
      counts.chinese++;
      counts.math++;
      counts.english++;
    } else {
      review.subjects.forEach(subject => {
        counts[subject]++;
      });
    }
  });

  return counts;
}
